import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Menu from "../../components/Menu.js";
import {
  Button,
  Table,
  Card,
  Badge,
  Spinner,
  Alert,
  Image,
} from "react-bootstrap";
import api from "../../api.js";
import DownloadButton from "../../components/DownloadButtonReport.js";
//import DownloadButtonDetails from "../../components/DownloadButtonReportRealizadoDetails.js";
import DownloadButtonDetailsNormal from "../../components/DownloadButtonReportRealizadoDetailsNormal.js";
import pdf from '../../assets/img/pdf.svg';

const DoctorTransferItem = () => {
  const navigate = useNavigate();
  const { id: idParam } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [payment, setPayment] = useState(null);
  const [data, setData] = useState([]);
  const [professionals, setProfessionals] = useState([]);
  const [totalProcedures, setTotalProcedures] = useState(0);

  const imageSrc = payment?.photo?.endsWith("pdf") ? pdf : payment?.photo;

  const formatCurrency = (value) =>
    new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(parseFloat(value || 0));

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("pt-BR");
  };

  const formatMonth = (monthString) => {
    if (!monthString) return "";
    const [year, month] = monthString.split("-");
    const date = new Date(year, parseInt(month) - 1, 1);
    return date.toLocaleString("pt-BR", { month: "long", year: "numeric" });
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const cashierRes = await api.post("/api/cashier/by-fund-transfer", {
          type: "req",
          fund_transfer_id: idParam,
        });

        setData(cashierRes.data.data);

        const repasseRes = await api.get(`/api/fund-transfers/${idParam}`);
        setPayment(repasseRes.data.data);

        setLoading(false);
      } catch (err) {
        console.error("Erro ao carregar dados:", err);
        setError("Erro ao carregar os dados.");
        setLoading(false);
      }
    };

    fetchData();
  }, [idParam]);

  useEffect(() => {
    if (!Array.isArray(data)) return;

    const formatted = [];

    data.forEach((cashier) => {
      if (!Array.isArray(cashier.items)) {
        console.warn("Cashier sem items:", cashier);
        return;
      }

      cashier.items.forEach((item) => {
        const found = formatted.find((f) => f.name === item.requesting_company);
        const value = parseFloat(item.transfer_value || 0);

        if (found) {
          found.procedures += 1;
          found.value += value;
        } else {
          formatted.push({
            id: item.procedure_id,
            name: item.requesting_company,
            procedures: 1,
            value,
          });
        }
      });
    });

    setProfessionals(formatted);
    setTotalProcedures(
      formatted.reduce((total, prof) => total + prof.procedures, 0)
    );
  }, [data]);

  // useEffect(() => {
  //   console.log("payment: ", payment);
  //   console.log("professionals: ", professionals);
  //   console.log("totalProcedures: ", totalProcedures);
  //   console.log("data: ", data);
  // }, [payment, professionals, totalProcedures, data]);

  if (loading) {
    return (
      <Menu
        screen={
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "80vh" }}>
            <Spinner animation="border" />
            <span className="ml-2">Carregando...</span>
          </div>
        }
      />
    );
  }

  if (error) {
    return (
      <Menu
        screen={
          <Alert variant="danger" className="m-4">
            <h4>Erro</h4>
            <p>{error}</p>
            <Button onClick={() => navigate("/financial/repasse-medico")}>
              Voltar
            </Button>
          </Alert>
        }
      />
    );
  }

  if (!payment) {
    return (
      <Menu
        screen={
          <Alert variant="warning" className="m-4">
            <h4>Dados não encontrados</h4>
            <Button onClick={() => navigate("/financial/repasse-medico")}>
              Voltar
            </Button>
          </Alert>
        }
      />
    );
  }

  return (
    <Menu
      screen={
        <div className="report-revenue-container p-4 mt-4 mb-4">
          <Card className="mb-4">
            <Card.Header className="d-flex justify-content-between align-items-center text-black">
              <h3 className="m-0">Relatório de Repasse Médico</h3>
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="col-md-6">
                  <h4>Detalhes do Repasse</h4>
                  <Table bordered hover responsive>
                    <tbody>
                      <tr>
                        <td>
                          <strong>Valor Total</strong>
                        </td>
                        <td>{formatCurrency(payment.total_amount)}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Período</strong>
                        </td>
                        <td>
                          {formatDate(payment.start_date)} a{" "}
                          {formatDate(payment.end_date)}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Porcentagem de Repasse</strong>
                        </td>
                        <td>
                          {payment.percentage_transfer}%
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Valor do Repasse</strong>
                        </td>
                        <td>
                          {formatCurrency(payment.full_transfer)}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Mês de Repasse</strong>
                        </td>
                        <td>{formatMonth(payment.transfer_month)}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Procedimentos</strong>
                        </td>
                        <td>{totalProcedures}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Data de Criação</strong>
                        </td>
                        <td>{formatDate(payment.created_at)}</td>
                      </tr>
                    </tbody>
                  </Table>

                  <div className="border p-3 rounded mt-3">
                    <DownloadButton dataPayments={payment} rawData={data} />
                  </div>
                  <div className="border p-3 rounded mt-3">
                    <DownloadButtonDetailsNormal
                      dataPayments={payment}
                      rawData={data}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <h4>Descrição</h4>
                  <div
                    className="border p-3 rounded mt-3"
                    style={{ minHeight: "100px" }}>
                    {payment.description || "Nenhuma descrição disponível"}
                  </div>

                  {payment.photo && (
                    <div className="mt-3">
                      <h4>Comprovante</h4>
                      <div className="text-center border p-2 rounded">
                        <a
                          href={payment.photo}
                          target="_blank"
                          rel="noopener noreferrer"
                          download>
                          <Image
                            src={imageSrc}
                            alt="Comprovante"
                            thumbnail
                            style={{ maxHeight: "100px" }}
                          />
                        </a>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Card.Body>
          </Card>

          <Card>
            <Card.Header>
              <h4 className="m-0">Profissionais</h4>
            </Card.Header>
            <Card.Body>
              {professionals.length === 0 ? (
                <Alert variant="info">Nenhum profissional encontrado.</Alert>
              ) : (
                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>Procedimentos</th>
                      <th>Valor</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {professionals.map((prof) => (
                      <tr key={prof.id}>
                        <td>{prof.name}</td>
                        <td className="text-center">{prof.procedures}</td>
                        <td>{formatCurrency(prof.value)}</td>
                        <td>
                          <Badge bg="success">Pago</Badge>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </Card.Body>
          </Card>

          <div className="mt-3">
            <Button
              variant="secondary"
              onClick={() => navigate("/financial/repasse-medico")}>
              Voltar
            </Button>
          </div>
        </div>
      }
    />
  );
};

export default DoctorTransferItem;
